import React, { useState, useEffect } from 'react';
import { Box, Button, Modal, Typography } from '@blueprint/ui';
import { useTranslation } from 'react-i18next';
import { axiosInstance } from '../../functions/axios';

const CaptchaErrorModal = ({ open, setOpen }) => {
    const { t } = useTranslation();
    
    

    

    return (
        <Modal
            open={open}
            onHide={() => setOpen(false)}
            closeIcon={true}
            onClickCloseIcon={() => setOpen(false)}
            size='small'
            activeFocusTrap={true}
            minHeight='230px'
        >
            <Box display='flex' justifyContent='center' width='100%' marginTop='10%'>
                <Box>
                    <Typography variant='h4' id='paymentsList-typo-modal-text' fontWeight='bold'>
                        {t('loginPage.captcha_error')}
                    </Typography>
                </Box>
            </Box>
            <Box
                position='absolute'
                bottom='0'
                py='1em'
                width='calc(100% - 80px)'
                display='flex'
                borderTop='1px solid #333'
                justifyContent= 'center'
            >
                <Button
                    onClick={() => {
                        setOpen(false);
                        window.location.reload();
                    }}
                    id='captcha-button-modal-yes'
                >
                    Reload
                </Button>
            </Box>
        </Modal>
    );
};

export default CaptchaErrorModal;